interface Event {
    headline: string;
    sub_headline: string;
    description: string;
    starts_at: string;
    ends_at: string;
    display_date: string;
    location: string;
    primary_image: string;
    background_image: string;
    created_by: string;
    edited_by: string;
}

interface EventResponse {
    data: Event[];
}

export default function eventList() {
    return {
        events: [] as Event[],
        isLoading: false,
        error: "",

        async init() {
            this.isLoading = true;
            this.error = "";

            try {
                const response = await fetch("https://selig.sincore.com/api/v1/events", {
                    method: "GET",
                    headers: {
                        Accept: "application/json",
                    },
                });

                if (!response.ok) {
                    throw new Error(`Server error: ${response.status}`);
                }

                const data = (await response.json()) as EventResponse;
                console.log(data);
                this.events = data.data;
            } catch (error) {
                this.error = error instanceof Error ? error.message : "Failed to fetch events";
                console.error("Event list fetch error:", error);
            } finally {
                this.isLoading = false;
            }
        },

        formatDate(dateString: string): string {
            if (!dateString) return "";
            const date = new Date(dateString.replace(/Z|[+-]\d{2}:\d{2}$/, ""));
            return new Intl.DateTimeFormat("en-US", {
                year: "numeric",
                month: "long",
                day: "numeric",
                hour: "numeric",
                minute: "2-digit",
                hour12: true,
                timeZone: "America/New_York",
            }).format(date);
        },
    };
}
